import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const ColorCoatedSteel = () => {
  const singleProductData = productData.filter((val) => val.id === 10);
  return (
    <>
      <Helmet>
        <title>
          Color Coated Steel Sheet | Stainless Steel Color Metal Sheets
        </title>
        <meta
          name="description"
          content="APF Steel, an experienced steel supplier providing customized color steel sheets according to customer needs."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default ColorCoatedSteel;
